export default "__VITE_ASSET__DIELPWXA__"